var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { OnWhen } from '@cvent/carina-layout';
import iconTypes from './StepIconTypes';
import useStyle from './StepperStyles';
import StepperProgressBar from './StepperProgressBar';
import RenderStep from './Step';
import HorizontalStep from './HorizontalStep';
import MobileStepper from './MobileStepper';
import { isStepWithSubSteps } from '../utils/isStep';
import { getStepIndex } from '../utils/getStepIndex';
/**
 * Stepper
 */
var Stepper = function (_a) {
    var currentStep = _a.currentStep, steps = _a.steps, _b = _a.isRtl, isRtl = _b === void 0 ? false : _b, _c = _a.onStepSelection, onStepSelection = _c === void 0 ? function () { } : _c, generateLabels = _a.generateLabels, _d = _a.presentation, presentation = _d === void 0 ? 'vertical' : _d, progressBarLabel = _a.progressBarLabel, _e = _a.showProgressBar, showProgressBar = _e === void 0 ? false : _e, _f = _a.showStepNumbers, showStepNumbers = _f === void 0 ? false : _f, _g = _a.strictNavigation, strictNavigation = _g === void 0 ? true : _g, propDrop = __rest(_a, ["currentStep", "steps", "isRtl", "onStepSelection", "generateLabels", "presentation", "progressBarLabel", "showProgressBar", "showStepNumbers", "strictNavigation"]);
    var wrapper = useStyle({ isRtl: isRtl, presentation: presentation }).wrapper;
    var addStepStatus = function (oldSteps, currStep) {
        return oldSteps.map(function (step) {
            if (step.status) {
                return step;
            }
            if (step.id === currStep) {
                if (isStepWithSubSteps(step)) {
                    return __assign(__assign({}, step), { status: iconTypes.active, subSteps: addStepStatus(step.subSteps, currentStep.subStep) });
                }
                return __assign(__assign({}, step), { status: iconTypes.active });
            }
            if (step.id < (currStep !== null && currStep !== void 0 ? currStep : 0)) {
                if (isStepWithSubSteps(step)) {
                    return __assign(__assign({}, step), { status: iconTypes.completed, subSteps: addStepStatus(step.subSteps, currentStep.subStep) });
                }
                return __assign(__assign({}, step), { status: iconTypes.completed });
            }
            if (isStepWithSubSteps(step)) {
                return __assign(__assign({}, step), { status: iconTypes.incomplete, subSteps: addStepStatus(step.subSteps, currentStep.subStep) });
            }
            return __assign(__assign({}, step), { status: iconTypes.incomplete });
        });
    };
    var stepsWithStatus = addStepStatus(steps, currentStep.step);
    if (presentation === 'horizontal') {
        return (_jsx("div", __assign({ css: wrapper }, propDrop, { children: stepsWithStatus.map(function (step, i) { return (_jsx(HorizontalStep, { name: step.name, isCurrentStep: getStepIndex(steps, currentStep.step) === i + 1, index: i + 1, showStepNumber: showStepNumbers, subHeading: step.subHeading, status: step.status, disabled: (strictNavigation && step.status === 'incomplete') ||
                    step.status === 'active', onClick: function () { return onStepSelection(step, i); }, generateLabel: generateLabels, isFirst: i === 0, isLast: i === stepsWithStatus.length - 1, isRtl: isRtl }, step.name)); }) }), void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(OnWhen, __assign({ defaultSize: true, s: true }, { children: _jsx(MobileStepper, { currentStep: currentStep, isRtl: isRtl, steps: stepsWithStatus, onStepSelection: onStepSelection, generateLabel: generateLabels, progressBarLabel: progressBarLabel, showStepNumbers: showStepNumbers, showProgressBar: showProgressBar, strictNavigation: strictNavigation }, void 0) }), void 0),
            _jsx(OnWhen, __assign({ m: true, l: true, xl: true }, { children: _jsxs("div", __assign({ css: wrapper }, propDrop, { children: [stepsWithStatus.map(function (step, i) { return (_jsx(RenderStep, { name: step.name, status: step.status, isFirst: i === 0, isLast: i === stepsWithStatus.length - 1, isCurrentStep: step.id === currentStep.step, disabled: (strictNavigation && step.status === 'incomplete') ||
                                step.status === 'active', onClick: function () { return onStepSelection(step, i); }, generateLabel: generateLabels, showStepNumber: showStepNumbers, index: i + 1, subHeading: step.subHeading, subSteps: step.subSteps, currentSubStep: currentStep.subStep, isRtl: isRtl }, step.id || step.name)); }),
                        showProgressBar && (_jsx(StepperProgressBar, { isRtl: isRtl, steps: stepsWithStatus, label: progressBarLabel }, void 0))] }), void 0) }), void 0)] }, void 0));
};
export default Stepper;
